/* Release 6.8 kit page (spec 25, 2.3 to 2.11). Deferred, loaded only by
   sections/au-r68-kit-main.liquid with au_r68_kit_page on.
   1. Gallery: a thumbnail shows its frame (desktop) or scrolls the strip to it
      (phone), the pill says "n / total · name"; on phone the pill follows the swipe.
   2. Quantity: the stepper sets the native quantity input (au-purchase owns the
      add) and the free shipping line follows it, as on the 6.2 product page.
   3. Separate adds (paused kit): the button says it is in the bag once
      au-purchase confirms the add.
   4. Analytics through AVAnalytics.custom, with the names on its allow list:
      kit_add_to_cart_attempt on the add (main or bar), kit_add_to_cart and
      kit_add_to_cart_success once au-purchase confirms, kit_add_to_cart_error,
      kit_notify_submit and kit_compare_click. Payload: the kit keys of
      av-kits.js plus handle and state. */
(() => {
  if (window.AUR68Kit) return;
  window.AUR68Kit = true;
  const track = (event, payload) => { try { window.AVAnalytics?.custom?.(event, payload); } catch (_) { /* analytics are optional */ } };
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  const phone = window.matchMedia('(max-width: 767px)');
  const money = (cents) => {
    try { if (window.theme?.formatMoney) { const s = document.createElement('span'); s.innerHTML = window.theme.formatMoney(Number(cents), window.theme.moneyFormat); return s.textContent; } } catch (_) { /* fall through */ }
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(Number(cents) / 100);
  };
  const payload = (root) => {
    const d = root?.dataset || {};
    return {
      source: 'kit_pdp', handle: d.handle || '', state: d.state || '',
      kit_handle: d.kitHandle || '', kit_name: d.kitName || '', kit_status: d.kitStatus || '',
      kit_entry_point: 'kit_pdp', kit_component_count: Number(d.kitComponentCount) || 0,
      kit_saving_percent: Number(d.kitSavingPercent) || 0
    };
  };
  const kitRoot = () => document.querySelector('[data-au-r68-kit]');

  /* 1. Gallery */
  const show = (gallery, n, scroll) => {
    const frames = [...gallery.querySelectorAll('[data-au-r68-frame]')];
    const frame = frames.find((f) => f.dataset.auR68Frame === String(n));
    if (!frame) return;
    frames.forEach((f) => f.classList.toggle('is-current', f === frame));
    gallery.querySelectorAll('[data-au-r68-thumb]').forEach((t) => t.setAttribute('aria-pressed', String(t.dataset.auR68Thumb === String(n))));
    const pill = gallery.querySelector('[data-au-r68-pill]');
    if (pill) pill.textContent = `${frames.indexOf(frame) + 1} / ${frames.length} · ${frame.dataset.label || ''}`;
    if (scroll && phone.matches) {
      const strip = gallery.querySelector('[data-au-r68-frames]');
      strip?.scrollTo({ left: frame.offsetLeft - strip.offsetLeft, behavior: reduce.matches ? 'auto' : 'smooth' });
    }
  };
  document.addEventListener('click', (event) => {
    const thumb = event.target.closest('[data-au-r68-thumb]');
    if (!thumb) return;
    const gallery = thumb.closest('[data-au-r68-gallery]');
    const changed = thumb.getAttribute('aria-pressed') !== 'true';
    show(gallery, thumb.dataset.auR68Thumb, true);
    // The creatine keeps today's gallery event (av-supplement.js: au_product_gallery_change, select_media).
    const section = gallery.closest('[data-av-supplement-main]');
    const frame = gallery.querySelector(`[data-au-r68-frame="${thumb.dataset.auR68Thumb}"]`);
    if (changed && section?.dataset.productId) track('au_product_gallery_change', { source: 'pdp', product_id: section.dataset.productId, variant_id: section.dataset.avVariantId, media_id: frame?.dataset.mediaId, media_role: frame?.dataset.mediaRole, position: Number(thumb.dataset.auR68Thumb) + 1, interaction_type: 'select_media' });
  });
  const watch = () => document.querySelectorAll('[data-au-r68-gallery]').forEach((gallery) => {
    const strip = gallery.querySelector('[data-au-r68-frames]');
    if (!strip || strip.dataset.auR68Watched) return;
    strip.dataset.auR68Watched = 'true';
    // On phone the thumbnails hide and the frames scroll sideways: the strip takes focus so the arrow keys reach every photo (as 6.2).
    const label = gallery.querySelector('.au-r68-gallery__thumbs')?.getAttribute('aria-label') || '';
    const focusable = () => {
      if (phone.matches) { strip.tabIndex = 0; strip.setAttribute('role', 'region'); strip.setAttribute('aria-label', label); }
      else { strip.removeAttribute('tabindex'); strip.removeAttribute('role'); strip.removeAttribute('aria-label'); }
    };
    focusable();
    phone.addEventListener?.('change', focusable);
    if (!('IntersectionObserver' in window)) return;
    const seen = new IntersectionObserver((entries) => {
      if (!phone.matches) return;
      const best = entries.filter((e) => e.isIntersecting && e.intersectionRatio >= 0.6)[0];
      if (best) show(gallery, best.target.dataset.auR68Frame, false);
    }, { root: strip, threshold: [0.6] });
    strip.querySelectorAll('[data-au-r68-frame]').forEach((frame) => seen.observe(frame));
  });

  /* 2. Quantity and the free shipping line */
  const setQuantity = (input, quantity) => {
    const q = Math.min(Number(input.max) || 99, Math.max(1, Math.floor(Number(quantity)) || 1));
    input.value = String(q);
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
    const ship = input.closest('.au-r68-kit__info')?.querySelector('[data-au-r62-ship]');
    if (!ship) return;
    const target = Number(ship.dataset.target) || 0;
    const total = (Number(ship.dataset.cart) || 0) + (Number(ship.dataset.price) || 0) * q;
    const left = Math.max(0, target - total);
    const line = ship.querySelector('[data-au-r62-ship-line]');
    if (line) line.textContent = left > 0 ? (ship.dataset.template || '').replace('[[amount]]', money(left)) : ship.dataset.done || '';
    const fill = ship.querySelector('[data-au-r62-ship-fill]');
    if (fill && target > 0) fill.style.width = `${Math.min(100, Math.floor((total * 100) / target))}%`;
  };
  document.addEventListener('click', (event) => {
    const step = event.target.closest('[data-au-r68-qty]');
    if (!step) return;
    const input = step.parentElement.querySelector('[data-au-r68-qty-input]');
    if (input) setQuantity(input, (Number(input.value) || 1) + Number(step.dataset.auR68Qty));
  });
  document.addEventListener('change', (event) => {
    const input = event.target.closest?.('[data-au-r68-qty-input]');
    if (input && event.isTrusted) setQuantity(input, input.value);
  });

  /* 3 and 4. Adds, separate adds and analytics */
  let pending = null;
  document.addEventListener('click', (event) => {
    const button = event.target.closest('button[type="submit"]');
    const form = button && (button.form || button.closest('form'));
    if (!form || !form.closest('[data-au-r68-kit]') || !form.classList.contains('au-r68-kit__form')) return;
    if (button.disabled || form.getAttribute('aria-busy') === 'true') return;
    pending = form;
    track('kit_add_to_cart_attempt', payload(kitRoot()));
  }, true);
  document.addEventListener('australia:purchase_confirmed', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.closest('[data-au-r68-kit], [data-au-r68-pair]')) return;
    if (form.classList.contains('au-r68-kit__form')) {
      pending = null;
      track('kit_add_to_cart', payload(kitRoot()));
      track('kit_add_to_cart_success', payload(kitRoot()));
      return;
    }
    const sep = form.querySelector('[data-au-r68-sep-add]');
    if (sep?.dataset.added) (sep.querySelector('[data-au-r68-sep-label]') || sep).textContent = sep.dataset.added;
  }, true);
  document.addEventListener('australia:purchase_state', (event) => {
    if (event.target !== pending || event.detail?.status !== 'error') return;
    pending = null;
    track('kit_add_to_cart_error', { ...payload(kitRoot()), error_state: 'add_to_cart_error' });
  }, true);
  document.addEventListener('submit', (event) => {
    if (event.target.closest?.('[data-au-r68-notify]')) track('kit_notify_submit', payload(kitRoot()));
  }, true);
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-au-r68-compare]');
    if (link) track('kit_compare_click', { ...payload(kitRoot()), target: link.dataset.auR68Compare || '' });
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch, { once: true });
  else watch();
  document.addEventListener('shopify:section:load', watch);
})();
